module.exports = __webpack_public_path__ + "img/m2.f6e61590.jpg";